// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationPoolPath = 'M53.575 12.016a4.866 4.866 0 119.732 0 4.866 4.866 0 01-9.732 0zM58.441 0c-6.636 0-12.016 5.38-12.016 12.016s5.38 12.016 12.016 12.016 12.016-5.38 12.016-12.016S65.077 0 58.44 0zm12.016 49.354v-7.15H46.425v7.15h24.032zm-.41-19.81H41.681c-3.212-5.817-7.913-8.164-12.1-8.824a18.673 18.673 0 00-7.392.349c-1.356.347-2.67.87-3.993 1.321l3.865 13.53a30.073 30.073 0 00-8.485 10.505H0v28.252h14.714a30.056 30.056 0 0014.83 12.692V100h21.92V89.449h7.622V100h21.922V87.359C92.119 82.985 100 72.174 100 59.496c0-16.543-13.41-29.953-29.953-29.953zm-41.58-1.762c-.457-.072-.904-.11-1.33-.123l3.218 11.263-2.221 1.438a22.907 22.907 0 00-8.888 10.933l-.885 2.282H7.15v13.952h11.92l.982 1.998c2.803 5.7 7.897 10.06 14.069 11.862l2.572.752V92.85h7.622V82.3h21.921V92.85h7.622V82.124l2.575-.75c9.489-2.766 16.417-11.513 16.417-21.878 0-12.595-10.208-22.803-22.803-22.803H37.088l-.927-2.171c-2.123-4.972-5.249-6.354-7.694-6.74z M27.174,52.827a4.5,4.5 0 1,0 9,0a4.5,4.5 0 1,0 -9,0';
var IllustrationPool = baseIllustration('IllustrationPool', {
  getPath: () => IllustrationPoolPath
}, 'ColoredIllustrationPool');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationPool;
//# sourceMappingURL=index.js.map